export class LoginConstants {
    static USERNAME_TEXT = "Username";
    static PASSWORD_TEXT = "Password";
    static USERNAME_REQUIRED_TEXT = "Username is required";
    static PASSWORD_REQUIRED_TEXT = "Password is required";
    static LOGIN_DIALOGUE_TITLE = "Log in";
    static LOGIN_BUTTON_TEXT = "LOGIN";
    static LOGIN_ERROR_TEXT = "Error occurred while logging in";
    static LOGIN_SPINNER_DIAMETER = 20;
    static LOGIN_SPINNER_MODE = "indeterminate";
    static REQUIRED_ERROR_CODE = "required";
    static USERNAME_FORM_CONTROL = "username";
    static PASSWORD_FORM_CONTROL = "password";
}
